import script from "./Rent.vue?vue&type=script&setup=true&lang=js"
export * from "./Rent.vue?vue&type=script&setup=true&lang=js"

import "./Rent.vue?vue&type=style&index=0&id=08c7f96e&lang=css"

const __exports__ = script;

export default __exports__